import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { AppWarning, RootState } from './store/models';
import { initState } from './store/stateinit';
import storePlugins from './store/plugins/index';

Vue.use(Vuex);
// Vue.config.devtools = true; // uncomment to enable vuedevtools on production
const store: StoreOptions<RootState> = {
  getters: {
    warnings(state): AppWarning[] {
      return state.options.warnings;
    },
    hasWarningsByType(state, getters): (type: string) => boolean {
      return (type: string) => {
        return getters.warnings.some((el: AppWarning) => el.type === type);
      };
    },
    postcodeValidationRule(state): string {
      const rules = ['required'];
      if (state.options.countrysettings.zipdigits) {
        rules.push('length:' + state.options.countrysettings.zipdigits);
      }
      return rules.join('|');
    },
  },
  mutations: {
    addWarning(state, warning: AppWarning) {
      state.options.warnings.push(warning);
    },
    removeWarningByType(state, warningType: string) {
      state.options.warnings.forEach((el: AppWarning, idx: number) => {
        if (el.type === warningType) {
          state.options.warnings.splice(idx, 1);
        }
      });
    },
  },
  state: {
    countryData: initState('countrydata'),
    options: initState('settings'),
  },
  plugins: storePlugins,
};

export default new Vuex.Store<RootState>(store);
